import classNames from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import type { IntlKey } from '../../../locales';

interface ButtonProps {
  onClicked: () => void;
}

export const CloseButton: FC<ButtonProps> = ({ onClicked }) => (
  <button
    type="button"
    className="btn btn-lg btn-flat-secondary"
    aria-label="Close"
    data-e2e="blotter-panel-close"
    onClick={onClicked}
  >
    <i className="icon">clear</i>
  </button>
);

interface LinkButtonProps {
  labelKey: IntlKey;
  className?: string;
  icon?: string;
  onClick: () => void;
  isDisabled?: boolean;
  e2e?: string;
}

export const LinkButton: FC<LinkButtonProps> = ({ e2e, labelKey, className, icon, onClick, isDisabled }) => {
  return (
    <button
      data-e2e={e2e}
      type="button"
      className={classNames(`btn btn-xl btn-discreet-primary btn-icon-start`, className)}
      onClick={onClick}
      disabled={isDisabled}
    >
      {icon && <i className="icon">{icon}</i>}
      <FormattedMessage id={labelKey} tagName="span" />
    </button>
  );
};
